import { render, staticRenderFns } from "./cr_endereco.vue?vue&type=template&id=084e73a6&"
import script from "./cr_endereco.vue?vue&type=script&lang=js&"
export * from "./cr_endereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('084e73a6')) {
      api.createRecord('084e73a6', component.options)
    } else {
      api.reload('084e73a6', component.options)
    }
    module.hot.accept("./cr_endereco.vue?vue&type=template&id=084e73a6&", function () {
      api.rerender('084e73a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/cr_endereco.vue"
export default component.exports